/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FinishAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function FinishAction({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/FinishAction"
  
}) {
let imagesValueData = fromData.useDataFormat({ viewPath,
context: 'images',
format: fromHelpers.isDisabled,
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let imagesValueData1 = fromData.useDataFormat({ viewPath,
context: 'images',
format: fromHelpers.isDisabled,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="flex-end"
 marginTop={dtSpaceM}
 type="primary"
 size="normal"
 data="images"
 format="helpers.js isDisabled"
 disabled={imagesValueData}
 data="images_request"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={imagesValueData1 ? "Saving..." : "Finish"}
 data="images"
 format="helpers.js isDisabled"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}